import { useState } from "react";
import { notifications } from "@mantine/notifications";
import {
  Button,
  Group,
  LoadingOverlay,
  Paper,
  Stack,
  Text,
  ThemeIcon,
} from "@mantine/core";
import { useLanguage } from "../../../../stores/LanguageStore";
import {
  IconCloudUpload,
  IconPhotoSensor2,
} from "@tabler/icons-react";
import ItemDeleter from "../../../../components/TableComponents/ItemDeleter";
import { parseDate } from "../../../../functions/dates";
import { deleteWebhook, testWebhook } from "../../../../api/ConfigsApi";
import WebhookActivator from "./WebhookActivator";
import EditWebhook from "./EditWebhook";

const WebhookItem = ({ item, handleReload }) => {
  const lang = useLanguage((s) => s.language);
  const [loading, setLoading] = useState(null);

  const handleTest = () => {
    setLoading("test");
    testWebhook(item?.id)
      .then((r) => {
        notifications.show({
          message: `${lang.webhooks.response}: ${r.data.reponse || "Error"}`,
          position: "top-center",
          autoClose: 5000
        });
      })
      .finally(() => setLoading(false));
  };

  return (
    <Paper component={Stack} withBorder p={"sm"} pos={"relative"}>
      <LoadingOverlay visible={loading} />
      <Group wrap="nowrap">
        <ThemeIcon color="black">
          <IconCloudUpload />
        </ThemeIcon>
        <Text size="lg">{item.name}</Text>

        <WebhookActivator item={item} setLoading={setLoading} />
      </Group>

      <Text>
        {lang.webhooks.event} : {lang.workflows.nodes.events[item.event_type]}
      </Text>

      <Group>
        <Group mr={8} miw={150}>
          <Text size="sm">{lang.webhooks.created_on} {parseDate(item?.created_on)}</Text>
        </Group>
      </Group>

      <Group>
        <Button
          loading={loading === "test"}
          variant="light"
          loadingPosition="center"
          leftSection={<IconPhotoSensor2 size={18} />}
          onClick={handleTest}
        >
          {lang.sync_zapier.test}
        </Button>

        <EditWebhook item={item} handleDone={handleReload} />

        <ItemDeleter
          deletedMessage={lang.webhooks.deleted}
          title_bold={`${item.name} #${item.id}`}
          handleDelete={deleteWebhook}
          id={item.id}
          onFinish={() => handleReload()}
        />
      </Group>
    </Paper>
  );
};

export default WebhookItem;
